import { useGetAuthPasswordReset } from "@boundless/bl-api-client/allauth/auth"
import {
  createFileRoute,
  Link,
  redirect,
  useNavigate,
} from "@tanstack/react-router"
import { z } from "zod"

import { ResetPasswordForm } from "@/components/account/ResetPasswordForm"
import { getAuthClient } from "@/lib/clients"

export const Route = createFileRoute("/(public)/_account/reset-password")({
  validateSearch: z.object({
    key: z.string(),
  }),
  beforeLoad: ({ context: { store } }) => {
    if (store.getState().isAuthenticated) {
      throw redirect({ to: "/" })
    }
  },
  component: RouteComponent,
  wrapInSuspense: false,
})

function RouteComponent() {
  const client = getAuthClient()
  const search = Route.useSearch()
  const navigate = useNavigate()

  const { error, isLoading } = useGetAuthPasswordReset(client, {
    query: {
      retry: false,
      refetchOnWindowFocus: false,
    },
    request: {
      headers: {
        "X-Password-Reset-Key": search.key,
      },
    },
  })

  if (isLoading) {
    return (
      <h2 className="text-3xl font-bold text-neutral-800">
        Validating reset link...
      </h2>
    )
  }

  if (error) {
    return (
      <>
        <div className="mb-4">
          <h2 className="text-3xl font-bold text-neutral-800">
            Invalid reset link
          </h2>
          <p className="text-lg text-neutral-500">
            This password reset link is invalid, has expired, or has already
            been used.
          </p>
        </div>
        <Link
          className="mt-4 block text-center text-neutral-500 underline"
          to="/login"
        >
          Back
        </Link>
      </>
    )
  }

  return (
    <>
      <div className="mb-4">
        <h2 className="text-3xl font-bold text-neutral-800">
          Set new password
        </h2>
        <p className="text-lg text-neutral-500">
          Enter your new password below.
        </p>
      </div>

      <ResetPasswordForm
        resetKey={search.key}
        onSuccess={() =>
          navigate({ to: "/login", search: { resetComplete: true } })
        }
      />
    </>
  )
}
